// nextTab is the tab an arrow, Home or End key moves to among `ids`, or null
// for any other key: the keyboard half of the tabs pattern, which a tablist
// promises and two plain buttons did not keep (#287).
export function nextTab<T>(key: string, ids: readonly T[], current: T): T | null {
  const at = ids.indexOf(current)
  switch (key) {
    case 'ArrowRight': return ids[(at + 1) % ids.length]
    case 'ArrowLeft': return ids[(at - 1 + ids.length) % ids.length]
    case 'Home': return ids[0]
    case 'End': return ids[ids.length - 1]
    default: return null
  }
}
